module.exports = __webpack_public_path__ + "static/media/madfit-6.3bb3dd39.jpg";